// Import network configurations
import { NETWORKS, TOKENS_BY_NETWORK, getDefaultNetwork, getDefaultToken } from './networks';

// Export networks for use in the application
export const SUPPORTED_NETWORKS = NETWORKS;

// For backward compatibility
export const POLYGON_CHAIN_ID = NETWORKS.polygon.chainId;
export const POLYGON_CHAIN_ID_HEX = NETWORKS.polygon.chainIdHex;

// Get the default network
export const DEFAULT_NETWORK = getDefaultNetwork();

// Get tokens for the default network
export const SUPPORTED_TOKENS = TOKENS_BY_NETWORK[DEFAULT_NETWORK.id];

// For backward compatibility
export const USDC_CONFIG = SUPPORTED_TOKENS.USDC;
export const USDT_CONFIG = SUPPORTED_TOKENS.USDT;

// Default token for payments
export const DEFAULT_TOKEN = getDefaultToken(DEFAULT_NETWORK.id);
